'use client';

import { stack } from '@/lib/stack';
import { useState } from 'react';
import { Link } from './link';
import { Tool } from './tool';

export const Stack = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <div className="grid gap-3">
        {stack
          .sort((a, b) => (b.affiliate ? 1 : -1))
          .filter((tool) => tool.featured || open)
          .map((tool) => (
            <Tool key={tool.name} {...tool} />
          ))}
      </div>
      {stack.some((tool) => !tool.affiliate) && (
        <div className="flex w-full items-center justify-between gap-4">
          <button
            type="button"
            onClick={() => setOpen(v => !v)}
            className="cursor-pointer text-left text-muted-foreground text-sm hover:text-foreground"
          >
            Show {!open ? 'more' : 'less'} tools...
          </button>
          <Link
            href="https://logo.dev"
            aria-label="Logo API"
            target="_blank"
            className="text-muted-foreground text-xs hover:text-foreground"
          >
            Logos provided by Logo.dev
          </Link>
        </div>
      )}
    </>
  );
};
